export default function (actualPercentage) {
  return {
    type: 'ACTUAL SCROLL TO',
    actualPercentage: actualPercentage
  };
}
